<lib-form-field-container
    [kind]="FormContainerKind.PayPal">
    <ng-content label select="[label]"></ng-content>
    <ng-content menu select="[menu]"></ng-content>
    <ng-content></ng-content>
</lib-form-field-container>
